import { IconButton, Stack, TextField, Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function FentraReadonlyUrlField({ label, value, helperText }) {
    return (
        <Stack direction="row" spacing={1} alignItems="flex-start">
            <TextField
                label={label}
                value={value}
                fullWidth
                size="small"
                InputProps={{ readOnly: true }}
                inputProps={{ sx: { fontFamily: "monospace", fontSize: 12 } }}
                helperText={helperText}
            />
            <Tooltip title="Copy to clipboard">
                <IconButton size="small" onClick={handleCopy} disabled={!value}>
                    <Iconify icon="mdi:content-copy" />
                </IconButton>
            </Tooltip>
        </Stack>
    )

    function handleCopy() {
        navigator.clipboard.writeText(value)
    }
}
